var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_663_6309)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 24,
    r: 18,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.529 15.8571C25.505 16.6044 24.651 17.5607 24.0221 18.6643C23.3931 19.7678 23.0032 20.9942 22.8775 22.2641C22.7473 23.5387 22.8889 24.8296 23.2931 26.0512C23.6972 27.2728 24.3546 28.3971 25.2216 29.3496C26.5772 30.8274 28.3693 31.8285 30.3283 32.2025C32.2873 32.5764 34.307 32.3028 36.0833 31.4229C37.2205 30.8387 38.2309 30.0367 39.0584 29.0615C39.2716 28.8015 39.4111 28.4881 39.4623 28.1539C39.5136 27.8198 39.4748 27.4769 39.3499 27.1608C39.225 26.8447 39.0187 26.5669 38.7521 26.3561C38.4856 26.1453 38.1686 26.0091 37.834 25.9617C33.1809 25.4168 30.5098 21.2437 31.8473 16.7117C31.9376 16.3854 31.9388 16.0397 31.8508 15.7107C31.7628 15.3817 31.5888 15.0814 31.3469 14.8409C31.105 14.6005 30.8041 14.4289 30.4755 14.3438C30.1469 14.2587 29.8025 14.2633 29.4783 14.3571C28.4205 14.6963 27.425 15.2026 26.529 15.8571Z",
    fill: "#272D55"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_663_6309",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.517647 0 0 0 0 0.686275 0 0 0 0 0.937255 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_663_6309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_663_6309",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/DarkMode.d88e2d5a5f202865398d417b6ba91978.svg";
export { ForwardRef as ReactComponent };